export const getCSS = ({ uid, themeColor, height, width, }) => `
/* Modal Content/Box */
@keyframes ${uid}_fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    visibility: hidden;
    opacity: 0;
  }
  100% {
    visibility: visible;
    opacity: 1;
  }
}

#${uid} {
  /* prevent container el from taking site space */
  height: 0;

  /* prevent special container cursors from leaking in*/
  cursor: default;
}

.${uid}_has_modal_visible {
  overflow: hidden;
}

.${uid}_close:hover,
.${uid}_close:focus {
  color: white;
  background: #${themeColor};
  text-decoration: none;
  cursor: pointer;
}

.${uid}_modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5000000000;
  background: rgba(0, 0, 0, 0.7);
}

.${uid}_modal-container {
  /* center the modal content */
  display: flex;
  justify-content: center;
  align-items: center;
}

.${uid}_modal {
  width: ${width};
  max-width: 500px;
  height: ${height};
  max-height: 100%;
  z-index: 100;
  background: white;
  border: none;
  border-radius: 10px;

  /* modal box-shadow */
  -webkit-box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  -moz-box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  box-shadow: 0 4px 24px rgba(0,0,0,0.5);
  -webkit-background-clip: padding-box;
  -moz-background-clip: padding-box;
  background-clip: padding-box;
}

.${uid}_closed {
  display: none;
}

.${uid}_modal-content {
  width: 100%;
  height: 100%;
  overflow: hidden;

  border-radius: 10px;
}

.${uid}_modal .close-button {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 20px;
  background: black;
  color: white;
  padding: 5px 10px;
  font-size: 1.3rem;
}

.${uid}_container {
    height: 100%;
    width: 100%;
    position: relative;
}

.${uid}_container iframe {
    height: 100%;
    width: 100%;
}

@media all and (max-width: ${width}) {
  .${uid}_modal {
    height: 100%;
    max-height:${height};
    top: 53%;
  }
}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9tb2RhbC9jc3MvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLENBQUMsRUFDckIsR0FBRyxFQUNILFVBQVUsRUFDVixNQUFNLEVBQ04sS0FBSyxHQU1OLEVBQUUsRUFBRSxDQUFDOzthQUVPLEdBQUc7Ozs7Ozs7Ozs7Ozs7O0dBY2IsR0FBRzs7Ozs7Ozs7R0FRSCxHQUFHOzs7O0dBSUgsR0FBRztHQUNILEdBQUc7O2lCQUVXLFVBQVU7Ozs7O0dBS3hCLEdBQUc7Ozs7Ozs7Ozs7R0FVSCxHQUFHOzs7Ozs7O0dBT0gsR0FBRztXQUNLLEtBQUs7O1lBRUosTUFBTTs7Ozs7Ozs7Ozs7Ozs7OztHQWdCZixHQUFHOzs7O0dBSUgsR0FBRzs7Ozs7Ozs7R0FRSCxHQUFHOzs7Ozs7Ozs7OztHQVdILEdBQUc7Ozs7OztHQU1ILEdBQUc7Ozs7OzZCQUt1QixLQUFLO0tBQzdCLEdBQUc7O2lCQUVTLE1BQU07Ozs7Q0FJdEIsQ0FBQyJ9